<template>
  <div>
    <b-row>
      <b-container class="content">
        <b-overlay :show="searchIsRunning" rounded="sm" spinner-variant="primary">
          <!-- Search view -->
          <SearchForm
            :params="model.params"
            @search="runSearch"
            @openFees="onOpenFees"
            @sort="onSort"
            @pagination="onPaginate"
            :key="'hSearchForm' + model.params.distribution"
            />
        </b-overlay>
        <template v-if="!searchIsRunning && model.params.done">
          <b-card class="mt-3 mt-sm-5 bg-light p-2" no-body>
            <b-row class="align-items-center">
              <b-col md="7">
                <SearchResultsSummary :params="model.params" results="model.results"></SearchResultsSummary>
              </b-col>
              <b-col md="5">
                <SortFields @sort="onSort" @pagination="onPaginate"></SortFields>
              </b-col>
            </b-row>
          </b-card>
          <Legend/>
          <template v-if="model.results.length">
            <HotelResult
              v-for="(result,resultIndex) in paginatedResults"
              :result="result"
              :key="'result' + resultIndex"
              :selected="isSelected(result)"
              :expanded="resultIndex === 0"
              :displayedMeal="result.categories[0].meals[0]"
              :params="model.params"
              :fees="model.fees"
              @info="onInfo([result])"
              @toggle="onToggle(result)"
              >
                <hr />
                <div class="table-responsive">
                  <table class="table table-sm table-hover border">
                    <thead class="t-head hh-t-head">
                      <td>Tip camera</td>
                      <td style="width:5px">&nbsp;</td>
                      <td>Tip masa</td>
                      <td>Pret catalog</td>
                      <td>Pret redus</td>
                      <td>Tip oferta</td>
                      <td>Alege</td>
                    </thead>
                    <tbody>
                      <CategoryResult
                        v-for="(category, catIndex) in result.categories"
                        :category="category"
                        :currency="model.params.currency"
                        :key="'cat' + catIndex"
                        :fees="model.fees"
                        :starRating="result.stars"
                        :noRooms="model.params.rooms.length"
                        transport="own"
                        @book="onBook({ resultId: result.id, categoryId: category.id, ...$event })"
                        @priceDetails="onPriceDetails({ result, category, ...$event })"
                        ></CategoryResult>
                    </tbody>
                  </table>
                </div>
              </HotelResult>
              <b-pagination
                v-model="currentPage"
                :totalRows="model.results.length"
                :per-page="resultsPerPage"
                @change="scrollToTop()"
                align="center"
                class="mt-4"
                pills
                />
          </template>
        </template>
      </b-container>
    </b-row>
    <b-modal v-model="feesModal" size="lg" hide-header hide-footer>
      <SimpleModalHeader  @closeModal="onCloseFeesModal" />
      <ServiceTax :fees="model.fees" />
      <ModalFooter @closeModal="onCloseFeesModal" />
    </b-modal>
    <SelectedResults
      :results="selectedResults"
      v-show="selectedResults.length"
      @hide="onHideSelected()"
      @info="onInfoSelected()"
      />
    <b-modal v-model="modal" size="xl" hide-header hide-footer>
      <div id="printArea">
        <ModalHeader @print="onPrint" @download="onDownload" @closeModal="onModalClose" />
        <SearchParamsSummary :params="model.params" class="ml-3"/>
        <b-row v-for="result in infoResults" :key="'detailedInfo' + result.id" class="p-4">
          <DetailedInfo
            :result="result"
            :currency="model.params.currency"
            :fees="model.fees"
            :noRooms="model.params.rooms.length"
          ></DetailedInfo>
        </b-row>
      </div>
      <ModalFooter @closeModal="onModalClose" />
    </b-modal>

    <b-modal v-model="priceDetailsModal" title="Price Details" size="lg" hide-header hide-footer>
      <SimpleModalHeader @closeModal="closePriceDetailsModal" />
      <PriceDetails
        :title="priceDetailsParams.title"
        :meal="priceDetailsParams.meal"
        :serviceTax="priceDetailsParams.serviceTax"
        :discounts="priceDetailsParams.discounts"
        :paymentSchedule="priceDetailsParams.paymentSchedule"
      />
      <ModalFooter @closeModal="closePriceDetailsModal" />
    </b-modal>
  </div>
</template>

<script>
import { getServiceFee } from 'b2b-common/utils/hotel'
import model from './services/model'

import viewMixin from '../shared/mixins/search_views'
import SearchForm from './components/search_form'
import SearchResultsSummary from './components/search_results_summary'
import SearchParamsSummary from './components/search_params_summary'
import HotelResult from '@/app/private/shared/components/hotel_result'
import CategoryResult from '@/app/private/shared/components/category_result'
import SimpleModalHeader from '../shared/components/simple_modal_header'
import ModalHeader from '../shared/components/modal_header'
import ModalFooter from '../shared/components/modal_footer'
import ServiceTax from './components/service_tax'
import DetailedInfo from './components/detailed_info'
import SelectedResults from '@/app/private/shared/components/selected_results'
import PriceDetails from '@/app/private/shared/components/price_details'
import SortFields from '@/app/private/shared/components/sort_fields'
import Legend from '@/app/private/shared/components/legend'

import { paymentSchedule } from 'b2b-common/services/api/hotel'

export default {
  components: {
    SearchForm,
    SearchResultsSummary,
    SearchParamsSummary,
    HotelResult,
    CategoryResult,
    ModalHeader,
    ModalFooter,
    SimpleModalHeader,
    ServiceTax,
    SelectedResults,
    DetailedInfo,
    PriceDetails,
    SortFields,
    Legend
  },
  mixins: [viewMixin],
  data () {
    return {
      model,
      feesModal: false,
      priceDetailsParams: {
        meal: null,
        title: '',
        discounts: [],
        paymentSchedule: [],
        serviceTax: 0
      }
    }
  },
  methods: {
    runSearch (params) {
      this.searchIsRunning = true
      model.search(params)
        .finally(() => { this.searchIsRunning = false })
    },
    onOpenFees () {
      this.feesModal = true
    },
    onCloseFeesModal () {
      model.saveFees()
      this.feesModal = false
    },
    onBook ({ resultId, categoryId, mealIndex }) {
      const route = {
        name: 'Private/Hotel/Book',
        params: {
          Result: resultId,
          Category: categoryId,
          Meal: mealIndex,
          Distribution: this.model.params.distribution
        }
      }
      this.$router.push(route)
    },
    async onPriceDetails ({ result, category, meal }) {
      this.priceDetailsParams.title = result.name
      this.priceDetailsParams.meal = meal
      this.priceDetailsParams.discounts = []
      if (Array.isArray(category.discounts)) this.priceDetailsParams.discounts = category.discounts
      this.priceDetailsParams.serviceTax = getServiceFee({
        meal: meal,
        starRating: result.stars,
        noRooms: this.model.params.rooms.length,
        fees: this.model.fees
      })
      this.priceDetailsParams.paymentSchedule = await paymentSchedule({
        source: result.source,
        category: category.id,
        meal: meal.id
      })
      this.priceDetailsModal = true
    }
  }
}
</script>
